import { gql } from '@apollo/client';

export const UPDATE_ORIGINATION_SOURCE_FUNNEL = gql`
  mutation Flex_updateOriginationSource($id: Int!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      originationSource {
        funnel
      }
    }
  }
`;
